export const DDC_VIDEO_PAUSE = 'ddc.video.pause';
export const VIDEO_PAUSE = 'video-pause';

function pause(event) {
	const {
		currentTarget: element,
		currentTarget: {
			duration: videoDuration = '',
			currentSrc: videoSource,
			currentTime = 0,
			ended = false,
			seeking = false
		} = {}
	} = event;

	// Browsers pause playback internally while the user scrubs the native seek
	// bar (confirmed in a real browser: element.seeking is already true by the
	// time this 'pause' handler runs). That is a seek artifact, not a user
	// pause — it's reported as ddc.video.seek instead (see seek.js).
	if (seeking) {
		return undefined;
	}

	// The browser also fires a native 'pause' when playback reaches the end.
	// That is a completion (reported via the 'ended' milestone), not a user
	// pause, so don't emit ddc.video.pause for it.
	if (ended || (videoDuration && currentTime >= videoDuration - 0.5)) {
		return undefined;
	}

	return {
		eventType: DDC_VIDEO_PAUSE,
		eventData: {
			element,
			videoSource,
			videoDuration,
			fileType:
				typeof videoSource === 'string'
					? videoSource.split('.').pop()
					: ''
		},
		overrides: {
			eventType: VIDEO_PAUSE
		}
	};
}

export default pause;
